import { useEffect, useState } from "react";

export default function Statistics() {
  const [visits, setVisits] = useState(0);
  const [avgTime, setAvgTime] = useState(0);
  const [time24h, setTime24h] = useState(0);
  const [startTime] = useState(Date.now());

  useEffect(() => {
    const visitsList = JSON.parse(localStorage.getItem("admin_visits_list") || "[]");

    // Increment total visits
    const newVisits = visitsList.length + 1;
    setVisits(newVisits);

    // Record time when leaving page
    const handleUnload = () => {
      const duration = Math.round((Date.now() - startTime) / 1000); // in seconds
      const newEntry = { duration, timestamp: Date.now() };

      const updatedList = [...visitsList, newEntry];
      localStorage.setItem("admin_visits_list", JSON.stringify(updatedList));

      // Calculate averages and 24-hour total
      const totalTime = updatedList.reduce((acc, v) => acc + v.duration, 0);
      const avg = Math.round(totalTime / updatedList.length);
      setAvgTime(avg);

      const last24 = updatedList
        .filter((v) => Date.now() - v.timestamp <= 24 * 60 * 60 * 1000)
        .reduce((acc, v) => acc + v.duration, 0);
      setTime24h(last24);
    };

    window.addEventListener("beforeunload", handleUnload);

    return () => {
      window.removeEventListener("beforeunload", handleUnload);
      handleUnload();
    };
  }, [startTime]);

  // On load → calculate current values
  useEffect(() => {
    const visitsList = JSON.parse(localStorage.getItem("admin_visits_list") || "[]");
    setVisits(visitsList.length);

    if (visitsList.length > 0) {
      const totalTime = visitsList.reduce((acc, v) => acc + v.duration, 0);
      setAvgTime(Math.round(totalTime / visitsList.length));

      const last24 = visitsList
        .filter((v) => Date.now() - v.timestamp <= 24 * 60 * 60 * 1000)
        .reduce((acc, v) => acc + v.duration, 0);
      setTime24h(last24);
    }
  }, []);

  // Commented out resetStats for now
  /*
  const resetStats = () => {
    localStorage.removeItem("admin_visits_list");
    setVisits(0);
    setAvgTime(0);
    setTime24h(0);
  };
  */

  return (
    <div style={{ padding: "2rem", fontFamily: "Inter, sans-serif" }}>
      <h2 style={{ fontSize: "1.8rem", fontWeight: 700, marginBottom: "1rem" }}>
        📊 Admin Page Statistics
      </h2>

      <div style={{ display: "flex", gap: "2rem", flexWrap: "wrap" }}>
        <div style={cardStyle}>
          <h3 style={titleStyle}>Total Visits</h3>
          <p style={valueStyle}>{visits}</p>
        </div>

        <div style={cardStyle}>
          <h3 style={titleStyle}>Average Time / Visit</h3>
          <p style={valueStyle}>{avgTime} sec</p>
        </div>

        <div style={cardStyle}>
          <h3 style={titleStyle}>Time Spent (Last 24h)</h3>
          <p style={valueStyle}>{time24h} sec</p>
        </div>
      </div>

      {/* Commented out reset button for now
      <button
        onClick={resetStats}
        style={{
          marginTop: "2rem",
          background: "#d4a017",
          color: "#fff",
          border: "none",
          padding: "10px 20px",
          borderRadius: "8px",
          cursor: "pointer",
          fontWeight: 600,
        }}
      >
        Reset Statistics
      </button>
      */}
    </div>
  );
}

const cardStyle = {
  flex: "1",
  minWidth: "200px",
  background: "rgba(255,255,255,0.9)",
  borderRadius: "10px",
  boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
  padding: "1.5rem",
  textAlign: "center",
  border: "1px solid #ddd",
};

const titleStyle = {
  fontSize: "1rem",
  fontWeight: 600,
  color: "#333",
  marginBottom: ".5rem",
};

const valueStyle = {
  fontSize: "1.8rem",
  fontWeight: 700,
  color: "#b8860b",
};
